import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripeCheckout from "../../Components/StripeCheckout";
import { useDispatch, useSelector } from "react-redux";
import {
  applyCoupon,
  createOrder,
  removeCoupon,
} from "../../Core/features/checkoutSlice";
import Loader from "../Loader";
import { toast } from "react-toastify";
import { toastStyle } from "../../Utils";
import arrowUp from "../../Assets/img/arrow_up.svg";
import arrowDown from "../../Assets/img/arrow_down.svg";

//publishable Stripe key
// const stripePromise = loadStripe("pk_live_84hnUuwsD6dLxytzxzRHN0nB");
const stripePromise = loadStripe(
  "pk_test_51PGPslP38WoOV3vpVv33IuVVQdvS9AJ8Nbls98sUd0O7ftoCX1tV7V7AahbcXLZ9pnDDYTwHndUONWdtzlYftoiq00Yp67uXTD"
);
const Checkout = ({ handleStart }) => {
  const stripeRef = useRef();
  // const [coupon, setCoupon] = useState("")
  const initialState = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    zipCode: null,
  };
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    company_name: "",
    zipCode: null,
  });
  const { productInfo, couponDetails } = useSelector(
    (state) => state.CheckoutState
  );
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // const [yearIsOpen, setYearIsOpen] = useState(false)
  // const [yearValue, setYearValue] = useState("")
  // const [couponLoading, setCouponLoading] = useState(false)
  // useEffect(() => {
  //   if (couponDetails) {
  //     setCoupon(couponDetails?.coupon_details?.coupon_code)
  //   }
  // }, [couponDetails])

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    console.log(value, "value");
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // const handleDropdown = () => {
  //   setYearIsOpen(!yearIsOpen)
  // }

  // const handleSetYear = (val) => {
  //   if (val) {
  //     setYearValue(val)
  //     setYearIsOpen(false)
  //   }
  // }

  const validate = () => {
    // Check if each field is empty or invalid
    if (!formData.firstName) {
      toast.error("First Name is required.", toastStyle);
      return false;
    }
    if (!formData.lastName) {
      toast.error("Last Name is required.", toastStyle);
      return false;
    }
    if (!formData.email) {
      toast.error("Email Address is required.", toastStyle);
      return false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      toast.error("Please enter a valid email address.", toastStyle);
      return false;
    }
    if (!formData.phone) {
      toast.error("Phone Number is required.", toastStyle);

      return false;
    }
    if (!formData.company_name) {
      toast.error("Company Name is required.", toastStyle);

      return false;
    }
    if (!formData.address) {
      toast.error("Address is required.", toastStyle);
      return false;
    }
    if (!formData.zipCode) {
      toast.error("Zip code is required.", toastStyle);
      return false;
    }
    // if (!formData.ein) {
    //   toast.error("EIN is required.", toastStyle)
    //   return false;
    // }
    // if (formData.ein?.length < 9) {
    //   toast.error("EIN Should be 9 Digits.", toastStyle)
    //   return false;
    // }
    // if (!yearValue) {
    //   toast.error("Tax Year is required.", toastStyle)
    //   return false;
    // }

    return true;
  };

  // const handlePayment = async () => {
  //   const isValid = validate();
  //   if (!isValid) return;
  //   setLoading(true)
  //   stripeRef.current
  //     ?.handleSubmit()
  //     .then((stripeResponse) => {
  //       console.log(stripeResponse, "stripeResponse")
  //       if (stripeResponse && stripeResponse?.error || !stripeResponse?.
  //         paymentMethod?.id) {
  //         setLoading(false)
  //         console.error(
  //           "Payment Error:",
  //           stripeResponse
  //         );
  //         toast.error(stripeResponse?.error ||
  //           "Payment failed: Token could not be generated.", toastStyle)
  //         return Promise.reject("Payment failed");
  //       } else if (stripeResponse) {
  //         const finalData = {
  //           order_id: productInfo?.product_id,
  //           first_name: formData.firstName,
  //           last_name: formData.lastName,
  //           company_name: formData?.company_name,
  //           email: formData.email,
  //           phone_number: formData.phone,
  //           // coupon_code: couponDetails ? couponDetails?.coupon_details?.coupon_code : coupon,
  //           address: formData.address,
  //           product_name: productInfo?.product_name,
  //           // discounted_price: couponDetails ? couponDetails?.coupon_details?.coupon_discount : "",
  //           original_price: productInfo?.product_price,
  //           // payment_id: stripeResponse?.paymentMethod?.id,
  //           zip_code: formData?.zipCode,
  //           couponDetails,
  //           // coupon_type: couponDetails?.coupon_details?.coupon_type ? couponDetails?.coupon_details?.coupon_type : "",
  //           // after_discount: couponDetails?.discounted_price ? couponDetails?.discounted_price : "",
  //           // ein: formData?.ein,
  //           // tax_year: yearValue,
  //           ...productInfo,
  //         };
  //         // setLoading(false)
  //         console.log(finalData, "finalDatafinalData")
  //         dispatch(createOrder(finalData)).then((payload) => {
  //           setLoading(false)
  //           if (payload?.payload?.success) {
  //             setFormData(initialState)
  //             toast.success("Payment Successful", toastStyle)
  //             dispatch({ type: "RESET_STATE" });
  //             handleStart('true')

  //           } else {
  //             toast.error(payload?.data?.data?.message || "Something Went Wrong.", toastStyle)
  //           }
  //         });

  //       }

  //     })
  //     .catch((err) => {
  //       console.log(err, "err----err")
  //       // toast.error(err?.message || "Something Went Wrong, contact us.", toastStyle)
  //       setLoading(false)
  //     });
  // };
  const handlePayment = async () => {
    const isValid = validate();
    if (!isValid) return;
    setLoading(true);
    try {
      const finalData = {
        product_id: productInfo?.product_id,
        first_name: formData.firstName,
        last_name: formData.lastName,
        company_name: formData?.company_name,
        email: formData.email,
        phone_number: formData.phone,
        address: formData.address,
        zip_code: formData?.zipCode,
        product_name: productInfo?.product_name,
        product_type: productInfo?.product_type,
        is_recurring: productInfo?.is_recurring,
        sub_products: productInfo?.sub_products,
        original_price: productInfo?.product_price,
        stripe_product_price_id: productInfo?.stripe_product_price_id,
        // coupon_code: couponDetails ? couponDetails?.coupon_details?.coupon_code : coupon,
        // discounted_price: couponDetails ? couponDetails?.coupon_details?.coupon_discount : "",
        // original_price: productInfo?.product_price,
        // payment_id: stripeResponse?.paymentMethod?.id,
        // couponDetails,
        // coupon_type: couponDetails?.coupon_details?.coupon_type ? couponDetails?.coupon_details?.coupon_type : "",
        // after_discount: couponDetails?.discounted_price ? couponDetails?.discounted_price : "",
        // ein: formData?.ein,
        // tax_year: yearValue,
        // ...productInfo,
      };
      console.log(finalData, "finalDatafinalData");
      dispatch(createOrder(finalData)).then((payload) => {
        setLoading(false);
        if (payload?.payload?.success) {
          console.log(payload?.payload, "payyyyy");
          // toast.success("Payment Successful", toastStyle);
          if (payload?.payload?.url) {
            sessionStorage.setItem("resetState", true);
            setFormData(initialState);
            window.location.href = payload?.payload?.url;
          }
        } else {
          toast.error(
            payload?.data?.data?.message || "Something Went Wrong.",
            toastStyle
          );
          console.log(payload, "payload?.data?.data?.messag");
        }
      });
    } catch (err) {
      console.log(err, "err----err");
      // toast.error(err?.message || "Something Went Wrong, contact us.", toastStyle)
      setLoading(false);
    }
  };

  // const handleCoupon = () => {
  //   if (couponDetails) {
  //     dispatch(removeCoupon())
  //     setCoupon("");
  //   } else if (coupon) {
  //     setCouponLoading(true)
  //     dispatch(applyCoupon({ code: coupon, price: productInfo?.product_price })).then((response) => { setCouponLoading(false) })
  //   } else {
  //     toast.error("Coupon Code is required", toastStyle)
  //   }
  // }

  // const optionYear = ["2025", "2024", "2023", "2022"]
  console.log(productInfo, "productinfo");
  useLayoutEffect(() => {
    const resetState = sessionStorage.getItem("resetState");
    console.log(resetState, "resetState");
    if (resetState) {
      console.log(resetState, "resetState inside if");
      dispatch({ type: "RESET_STATE" });
      sessionStorage.removeItem("resetState");
    }
  }, []);

  return (
    <div class="form-step active" id="step-8">
      <h2>Checkout</h2>
      <div class="checkout_wrapper">
        <div class="secure_payment">
          <div class="form_inner">
            <div class="checkout_form_wrapper">
              <h1>Secure Payment</h1>
              <div class="field_col">
                <label>Personal Details</label>
                <div class="double_filed field_wrapper">
                  <div class="input_wrapper">
                    <input
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      value={formData.firstName}
                      onChange={handleFormChange}
                    />
                  </div>
                  <div class="input_wrapper">
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      value={formData.lastName}
                      onChange={handleFormChange}
                    />
                  </div>
                </div>
                <div class="double_filed field_wrapper">
                  <div class="input_wrapper">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={handleFormChange}
                    />
                  </div>
                  <div class="input_wrapper">
                    <input
                      type="text"
                      name="company_name"
                      placeholder="Company Name"
                      value={formData.company_name}
                      onChange={handleFormChange}
                    />
                  </div>
                </div>
                <div class="field_wrapper"></div>
                <div class="field_wrapper">
                  <div class="input_wrapper">
                    <input
                      type="number"
                      name="phone"
                      placeholder="Phone Number"
                      value={formData.phone}
                      onChange={handleFormChange}
                    />
                  </div>
                </div>
                <div class="field_wrapper">
                  <div class="input_wrapper">
                    <input
                      type="text"
                      name="address"
                      placeholder="Your Address..."
                      value={formData.address}
                      onChange={handleFormChange}
                    />
                  </div>
                  <div class="input_wrapper">
                    <input
                      type="number"
                      name="zipCode"
                      placeholder="Zip Code"
                      value={formData.zipCode}
                      onChange={handleFormChange}
                    />
                  </div>
                  {/* <div class="input_wrapper">
                    <input
                      type="number"
                      name="ein"
                      placeholder="EIN"
                      value={formData.ein}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d{0,9}$/.test(value)) {
                          handleFormChange(e);
                        }
                      }}

                      maxLength={9}
                    />
                  </div>

                  <div className="custom_drodown_ctax">
                    <div className="dropdown_value" onClick={() => handleDropdown()}>
                      <p className="value">{yearValue ? yearValue : "Tax Year"}</p>
                      <div className="arrow">
                        {yearIsOpen ? <img src={arrowUp} alt="" /> : <img src={arrowDown} alt="" />}
                      </div>
                    </div>
                    {yearIsOpen &&
                      <div className="custom_drodown_ctax_options">
                        <ul>
                          {optionYear?.map((val) => (
                            <li onClick={() => handleSetYear(val)}>{val}</li>
                          ))}
                        </ul>
                      </div>
                    }
                  </div> */}
                </div>
              </div>
              {/* <div class="field_col">
                <label>Coupon</label>
                <div class="coupon_field">
                  <input
                    type="text"
                    name="coupon"
                    placeholder="Coupon Code..."
                    value={coupon}
                    onChange={(e) => setCoupon(e.target.value)}
                  />
                  <button
                    onClick={() => handleCoupon()}
                    type="button"
                    name="apply"
                    value="apply"
                    disabled={couponLoading}
                    class="apply_btn"
                  >
                    {couponLoading ? <Loader /> : couponDetails ? "Remove" : "Apply"}

                  </button>
                </div>
              </div>
              <div class="field_col">
                <label>
                  Credit Card <span>(Required)</span>
                </label>
                <div class="field_wrapper">
                  <div class="input_wrapper">
                    <Elements stripe={stripePromise}>
                      <StripeCheckout ref={stripeRef} product={productInfo} />
                    </Elements>
                  </div>
                </div>
              </div> */}
            </div>
            <div class="order_summary">
              <h2>Order Summary</h2>
              <form>
                <table class="summary-table">
                  {~Array.isArray(productInfo) && productInfo && (
                    <>
                      {productInfo?.sub_products &&
                        productInfo?.sub_products?.length == 0 && (
                          <>
                            <h3>Product Breakdown</h3>
                            <tbody
                              className={
                                productInfo?.sub_products &&
                                productInfo?.sub_products?.length > 0
                                  ? "sub_product_body"
                                  : ""
                              }
                            >
                              <tr>
                                <td
                                  className="order_summary_product_name"
                                  colSpan="3"
                                >
                                  {productInfo?.product_name}
                                </td>
                                <td
                                  className="order_summary_product_price"
                                  class="serviceName"
                                >
                                  ${productInfo?.product_price}
                                </td>
                              </tr>
                            </tbody>
                          </>
                        )}

                      {productInfo?.sub_products &&
                        productInfo?.sub_products?.length > 0 && (
                          <>
                            <h3>Product Breakdown</h3>
                            <tbody>
                              {productInfo?.sub_products?.map(
                                (subItem, index) => (
                                  <tr>
                                    <td
                                      className="order_summary_product_name"
                                      colSpan="3"
                                    >
                                      {subItem?.sub_prod_name}{" "}
                                      {subItem?.sub_prod_base_quantity
                                        ? `X ${subItem?.sub_prod_base_quantity}`
                                        : ""}
                                    </td>
                                    <td
                                      className="order_summary_product_price"
                                      class="serviceName"
                                    >
                                      ${subItem?.sub_prod_price}
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </>
                        )}
                      <tfoot>
                        {/* {couponDetails && couponDetails?.discounted_price && (
                          <tr>
                            <td colSpan="3">
                              <strong>Discount</strong>
                            </td>
                            <td>

                              <strong>- {couponDetails?.coupon_details?.coupon_type !== 'percentage' && "$"} {couponDetails && couponDetails?.coupon_details?.coupon_discount}{couponDetails?.coupon_details?.coupon_type == 'percentage' && "%"}</strong>
                            </td>
                          </tr>
                        )} */}
                        <tr>
                          <td colSpan="3">
                            <strong>Total</strong>
                          </td>
                          <td>
                            {/* <strong>${couponDetails ? couponDetails?.discounted_price : productInfo?.product_price}</strong> */}
                            <strong>
                              $
                              {productInfo?.product_price
                                ? productInfo?.product_price
                                : ""}
                            </strong>
                          </td>
                        </tr>
                      </tfoot>
                    </>
                  )}
                </table>
                <button
                  type="button"
                  className="purchase_btn"
                  disabled={loading}
                  onClick={handlePayment}
                  // onClick={() => {
                  //   dispatch({ type: "RESET_STATE" });
                  //   handleStart('true')
                  // }}
                  //  disabled={!isCardValid}
                >
                  {loading ? <Loader /> : "Pay"}
                </button>
                <div
                  id="payment-message"
                  // style="text-align: center; padding: 10px; font-size: medium; margin-top: 10px; color: green;"
                ></div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
